import { useState } from 'react';
import useAuthStore from '../stores/authStore';

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const login = useAuthStore((s) => s.login);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(email, password);
    } catch (err) {
      setError(err.response?.data?.message || 'Login fehlgeschlagen.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-bg flex items-center justify-center p-4">
      <div className="w-full max-w-[380px]">
        <div className="text-center mb-8">
          <div className="flex items-center justify-center gap-3 mb-3">
            <svg width="36" height="36" viewBox="0 0 32 32" fill="none">
              <circle cx="16" cy="16" r="14" stroke="#1C2E3C" strokeWidth="2" />
              <circle cx="16" cy="16" r="6" stroke="#1C2E3C" strokeWidth="2" />
              <line x1="16" y1="2" x2="16" y2="9" stroke="#1C2E3C" strokeWidth="2" strokeLinecap="round" />
              <line x1="16" y1="23" x2="16" y2="30" stroke="#1C2E3C" strokeWidth="2" strokeLinecap="round" />
              <line x1="2" y1="16" x2="9" y2="16" stroke="#1C2E3C" strokeWidth="2" strokeLinecap="round" />
              <line x1="23" y1="16" x2="30" y2="16" stroke="#1C2E3C" strokeWidth="2" strokeLinecap="round" />
            </svg>
            <span className="text-sidebar font-bold text-lg">KonversionOptimus AI</span>
          </div>
          <p className="text-gray-500 text-[13px]">CRO Platform · konversion.digital</p>
        </div>

        <form onSubmit={handleSubmit} className="bg-white rounded-xl shadow-sm border border-black/[.07] p-6">
          <h2 className="text-[18px] font-bold mb-5">Anmelden</h2>

          {error && (
            <div className="mb-4 p-3 bg-red-light rounded-lg text-red text-[12px]">{error}</div>
          )}

          <div className="mb-4">
            <label className="text-[12px] text-gray-500 block mb-1.5 font-medium">E-Mail</label>
            <input
              type="email"
              className="w-full border border-gray-200 rounded-lg px-3.5 py-2.5 text-[13px] outline-none focus:border-teal"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="name@firma.de"
              required
            />
          </div>

          <div className="mb-6">
            <label className="text-[12px] text-gray-500 block mb-1.5 font-medium">Passwort</label>
            <input
              type="password"
              className="w-full border border-gray-200 rounded-lg px-3.5 py-2.5 text-[13px] outline-none focus:border-teal"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
              required
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full bg-teal text-white py-3 rounded-lg font-medium text-[14px] hover:opacity-90 disabled:opacity-50"
          >
            {loading ? 'Wird angemeldet…' : 'Anmelden'}
          </button>
        </form>

        <p className="text-center text-gray-400 text-[11px] mt-6">
          © {new Date().getFullYear()} konversion.digital · David Odenthal
        </p>
      </div>
    </div>
  );
}
